// extracted by mini-css-extract-plugin
export default {"page":"PagamentoBoleto_page__Ogceb","icon":"PagamentoBoleto_icon__AWhC2","btn":"PagamentoBoleto_btn__J73aI","btnSecundario":"PagamentoBoleto_btnSecundario__fm8rK"};